export default "__VITE_ASSET__BCdWbA5k__"